@use "../ProductCard/index.module" as productCard;

.root {
    position: relative;
    grid-row: span productCard.$vertical-row-span;
    overflow: hidden;

    // Everything is position: absolute, which works great in a grid where an
    // adjacent ProductCard can set the desired height. But if GridPromoCard
    // ever stands alone or side-by-side, it'll look like a mess. This pseudo
    // gives it some intrinsic sizing.
    &::before {
        content: "";
        display: block;
        aspect-ratio: 7 / 8;
    }

    &:has(a):not(:has(video)) {
        cursor: pointer;
    }
}

.media {
    position: absolute;
    inset: 0;

    img,
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.mediaWithOverlay {
    composes: media;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-black-gradient);
        scale: 1 -1;
        pointer-events: none;
        z-index: 1;
    }
}

.content {
    position: absolute;
    inset: 0;
    padding: var(--spacer-32);
    overflow: hidden;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: var(--align-main, flex-start);
    align-items: var(--align-cross, flex-start);
    text-align: var(--text-align, left);
}

.measure {
    composes: content;
    visibility: hidden;
    pointer-events: none;
}

.clampedHeading {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.imageBlock {
    display: block;
    width: var(--image-width, 100%);
    max-width: var(--image-max-width, none);

    img {
        width: 100%;
        height: auto;
        display: block;
    }
}
